import { render, staticRenderFns } from "./UnblockVendor.vue?vue&type=template&id=47164402&"
import script from "./UnblockVendor.vue?vue&type=script&lang=js&"
export * from "./UnblockVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports